<template>
  <UIInputTextBase
    :id="id"
    ref="searchField"
    class="UIInputSearch"
    leadIcon="search"
    :modelValue="modelValue"
    :placeholder="placeholder"
    :trailIcon="trailIcon"
    @update:modelValue="onChangeSearch"
    @clicktrailIcon="clearValue"
  />
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import { UIInputTextBase, type IIcons } from '@foundever/ui-lib'

import { redactCardNumbers } from '@/utils/cardNumberRedaction'

const props = withDefaults(
  defineProps<{
    modelValue?: string
    placeholder?: string
    id?: string
    /**
     * If false, the clear button (X) will not be shown
     */
    showClearButton?: boolean
  }>(),
  {
    modelValue: '',
    placeholder: 'Search',
    id: 'search',
    showClearButton: true,
  },
)

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const trailIcon = computed((): IIcons | undefined => {
  if (!props.showClearButton || !props.modelValue) return undefined
  return 'close'
})

const searchField = ref<InstanceType<typeof UIInputTextBase>>()
const onChangeSearch = (value: string) => {
  emit(
    'update:modelValue',
    redactCardNumbers(value, {
      inputElement: searchField.value?.inputElement,
    }),
  )
}

const clearValue = () => {
  emit('update:modelValue', '')
}
</script>

<style scoped lang="scss">
.UIInputSearch {
  width: 100%;
}
</style>
